import React from 'react';

import { Tab } from './tab';
import type { TabProps } from './tabs.types';

export function getActiveId(
  activeId: React.Key | undefined,
  defaultActiveId: React.Key | undefined,
  tabsIds: React.Key[]
): React.Key | null {
  if (activeId && tabsIds.includes(activeId)) {
    return activeId;
  }
  if (defaultActiveId && tabsIds.includes(defaultActiveId)) {
    return defaultActiveId;
  }
  return tabsIds[0];
}

export function filterOnlyTabs(children: React.ReactNode) {
  return React.Children.toArray(children).filter(
    (child) => React.isValidElement(child) && child.type === Tab
  ) as React.ReactElement<TabProps>[];
}
